// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__BQr93","header":"FAQ_header__3Jm75","header_wrapper":"FAQ_header_wrapper__lbKii","header_text":"FAQ_header_text__mKZwu","question":"FAQ_question__lTFmu"};